'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _d3Ease = require('d3-ease');

var ease = _interopRequireWildcard(_d3Ease);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.default = {
  linear: ease.easeLinear,
  quad: ease.easeQuad,
  quadIn: ease.easeQuadIn,
  quadOut: ease.easeQuadOut,
  quadInOut: ease.easeQuadInOut,
  cubic: ease.easeCubic,
  cubicIn: ease.easeCubicIn,
  cubicOut: ease.easeCubicOut,
  cubicInOut: ease.easeCubicInOut,
  poly: ease.easePoly,
  polyIn: ease.easePolyIn,
  polyOut: ease.easePolyOut,
  polyInOut: ease.easePolyInOut,
  sin: ease.easeSin,
  sinIn: ease.easeSinIn,
  sinOut: ease.easeSinOut,
  sinInOut: ease.easeSinInOut,
  exp: ease.easeExp,
  expIn: ease.easeExpIn,
  expOut: ease.easeExpOut,
  expInOut: ease.easeExpInOut,
  circle: ease.easeCircle,
  circleIn: ease.easeCircleIn,
  circleOut: ease.easeCircleOut,
  circleInOut: ease.easeCircleInOut,
  bounce: ease.easeBounce,
  bounceIn: ease.easeBounceIn,
  bounceOut: ease.easeBounceOut,
  bounceInOut: ease.easeBounceInOut,
  back: ease.easeBack,
  backIn: ease.easeBackIn,
  backOut: ease.easeBackOut,
  backInOut: ease.easeBackInOut,
  elastic: ease.easeElastic,
  elasticIn: ease.easeElasticIn,
  elasticOut: ease.easeElasticOut,
  elasticInOut: ease.easeElasticInOut
};
//# sourceMappingURL=easing.js.map


//////////////////
// WEBPACK FOOTER
// ./~/react-prop-transition/lib/easing.js
// module id = 1329
// module chunks = 0